var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ViewTemplateSelectOption',{attrs:{"title":"Selecione a opção para cadastro","panel":_vm.panel,"options":_vm.options,"clickedNext":_vm.navegateTo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }